// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"86911db133205c9c","9401":"64d6182f1da83667"}[chunkId] + ".css";
};